import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { DividerModule } from 'primeng/divider';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-products',
  imports: [CommonModule, ButtonModule, DividerModule, LineBreakPipe],
  templateUrl: './products.component.html',
})
export class ProductsComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  redirect(product: any) {
    if(product.value.url) {
      window.open(product.value.url, '_blank');
    }
  }
}
